'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _keyCode = require('../utils/keyCode');

var _keyCode2 = _interopRequireDefault(_keyCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Higher-order component that encapsulates Token behaviors, allowing them to
 * be easily re-used.
 */
var TokenContainer = function TokenContainer(Component) {
  return (0, _reactOnclickoutside2.default)(_react2.default.createClass({
    getInitialState: function getInitialState() {
      return {
        selected: false
      };
    },
    render: function render() {
      return _react2.default.createElement(Component, _extends({}, this.props, this.state, {
        onBlur: this._handleBlur,
        onClick: this._handleSelect,
        onFocus: this._handleSelect,
        onKeyDown: this._handleKeyDown
      }));
    },
    _handleBlur: function _handleBlur(e) {
      (0, _reactDom.findDOMNode)(this).blur();
      this.setState({ selected: false });
    },
    _handleKeyDown: function _handleKeyDown(e) {
      switch (e.keyCode) {
        case _keyCode2.default.BACKSPACE:
          if (this.state.selected) {
            // Prevent backspace keypress from triggering the browser "back"
            // action.
            e.preventDefault();
            this._handleRemove();
          }
          break;
      }
    },


    /**
     * From `onClickOutside` HOC.
     */
    handleClickOutside: function handleClickOutside(e) {
      this._handleBlur();
    },
    _handleRemove: function _handleRemove(e) {
      this.props.onRemove && this.props.onRemove();
    },
    _handleSelect: function _handleSelect(e) {
      e.stopPropagation();
      this.setState({ selected: true });
    }
  }));
};

exports.default = TokenContainer;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap-typeahead/lib/containers/TokenContainer.js
 ** module id = 1502
 ** module chunks = 0
 **/